import styled from "styled-components";

const toRem = (px: number) => `${px / 16}rem`;

export const IconSlot = styled.span<{ $color: string; $size: number }>`
  display: inline-flex;
  flex-shrink: 0;
  width: ${({ $size }) => toRem($size)};
  height: ${({ $size }) => toRem($size)};
  color: ${({ $color }) => $color};

  svg {
    width: 100%;
    height: 100%;
  }
`;
